/**
 * Streak milestones. Completion is marked in ink (checks draw, strikes sweep, the
 * "Every habit, done." note); the only extra moment is the full-screen streak card
 * for 100- and 365-day streaks.
 */

const LEGENDARY_STREAKS = [100, 365];

/**
 * Open the streak card when a habit reaches a legendary streak.
 * App.js listens for 'legendary-streak' and renders LegendaryStreakCelebration.
 * @param {number} newStreak - The streak after this completion
 * @param {number} previousStreak - The streak before it
 */
export const checkStreakMilestone = (newStreak, previousStreak = 0) => {
  if (previousStreak < newStreak && LEGENDARY_STREAKS.includes(newStreak)) {
    window.dispatchEvent(new CustomEvent('legendary-streak', { detail: { streak: newStreak } }));
  }
};
